module.exports = __webpack_public_path__ + "img/logo-innovare-dark.6cffabc8.png";